declare global {
    interface Window {
        FWP: any;
        jQuery: any;
    }
}

/**
 * Scroll to the top of the FacetWP results when the page loads.
 */
export const facetWPScrollRefresh = () => {
    const $ = window.jQuery;
    if ( ! $ ) {
        return;
    }

    // Watch for FacetWP loaded event.
    document.addEventListener('facetwp-loaded', () => {
        if ( FWP.loaded ) {
            $('html, body').animate({
                scrollTop: $( '.facetwp-template' ).offset().top
            }, 500 );
        }
    } );
};
